import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectOfferValue = state => state.get('offerValue', initialState);

const makeSelectMonthlyRate = () =>
  createSelector(selectOfferValue, offerValueState =>
    parseInt(offerValueState.get('monthlyRate')),
  );

const makeSelectDeposit = () =>
  createSelector(selectOfferValue, offerValueState =>
    parseInt(offerValueState.get('deposit')),
  );

const makeSelectRightLabel = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('rightLabel'),
  );

const makeSelectFastDelivery = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('fastDelivery'),
  );

const makeSelectDeliveryTime = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('deliveryTime'),
  );

const makeSelectDeliveryTimes = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('deliveryTimes'),
  );

const makeSelectBroker = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('broker'),
  );

const makeSelectBrokers = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('brokers'),
  );

const makeSelectProduct = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('product'),
  );

const makeSelectProducts = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('products'),
  );

const makeSelectNotes = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('notes'),
  );

const makeSelectPrivateNotes = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('private_notes'),
  );

const makeSelectDuration = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('duration'),
  );

const makeSelectDistance = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('distance'),
  );

const makeSelectReference = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('reference_code'),
  );

const makeSelectHasError = () =>
  createSelector(selectOfferValue, offerValueState =>
    offerValueState.get('hasError'),
  );

const makeIsOfferValueComplete = () =>
  createSelector(selectOfferValue, offerValueState => {
    return offerValueState.get('monthlyRate') > 0
        && offerValueState.get('deposit') !== null
        && offerValueState.get('broker') !== null
        && offerValueState.get('product') !== null
        && !isNaN(offerValueState.get('deposit'))
        && offerValueState.get('deposit') >= 0
        && offerValueState.get('duration') > 0
        && offerValueState.get('distance') > 0
  });

export {
  selectOfferValue,
  makeSelectMonthlyRate,
  makeSelectDeposit,
  makeSelectDuration,
  makeSelectRightLabel,
  makeSelectDistance,
  makeSelectHasError,
  makeIsOfferValueComplete,
  makeSelectNotes,
  makeSelectPrivateNotes,
  makeSelectReference,
  makeSelectFastDelivery,
  makeSelectDeliveryTime,
  makeSelectDeliveryTimes,
  makeSelectBroker,
  makeSelectBrokers,
  makeSelectProducts,
  makeSelectProduct
};
